<template>
  <div class="login-page-wrapper">
    <div class="login-container">
      <div class="login-left-panel">
        <div class="logo-section">
          <img src="@/assets/logo1.png" alt="弘笃" class="logo-image" />
        </div>
      </div>

      <div class="login-right-panel">
        <div class="login-form-wrapper">
          <div class="login-header">
            <p class="login-title">欢迎登录弘笃智慧云管理系统</p>
            <p class="login-subtitle">登录您的账号</p>
          </div>

          <a-form
            id="formLogin"
            ref="formRef"
            class="user-layout-login"
            :model="form"
            :rules="rules"
          >
            <a-alert
              v-if="isLoginError"
              type="error"
              show-icon
              style="margin-bottom: 24px; border-radius: 8px"
              :message="loginErrorInfo"
              closable
              @after-close="handleCloseLoginError"
            />

            <a-form-item
              name="accountNo"
              label="账号"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-input
                v-model:value="form.accountNo"
                size="large"
                placeholder="请输入账号"
                class="login-input"
              />
            </a-form-item>

<!-- 当存在多个部门时，展示部门选择 -->
            <a-form-item
              v-if="deptOptions.length > 1"
              name="deptId"
              label="所属公司"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-select
                v-model:value="form.deptId"
                size="large"
                placeholder="请选择公司"
                class="login-input"
              >
                <a-select-option
                  v-for="dept in deptOptions"
                  :key="dept.deptId"
                  :value="dept.deptId"
                >
                  {{ dept.deptName || dept.deptId }}
                </a-select-option>
              </a-select>
            </a-form-item>


            <a-form-item
              name="password"
              label="密码"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
              class="password-form-item"
            >




              <a-input-password
                v-model:value="form.password"
                size="large"
                placeholder="请输入密码"
                class="login-input"
              />
            </a-form-item>

            
            

            <a-form-item class="remember-me-item">
              <label class="custom-checkbox-wrapper">
                <input
                  type="checkbox"
                  v-model="form.rememberMe"
                  @change="rememberMe"
                  class="custom-checkbox-input"
                />
                <span class="custom-checkbox-inner"></span>
                <span class="custom-checkbox-label">自动登录</span>
              </label>
            </a-form-item>

            <a-form-item style="margin-top: 24px">
              <a-button
                size="large"
                type="primary"
                class="login-button"
                :loading="logining"
                :disabled="logining"
                @click.prevent="handleLoginClick"
              >
                立即登录
              </a-button>
            </a-form-item>

            <div class="agreement-section">
              <label class="custom-checkbox-wrapper">
                <input
                  type="checkbox"
                  v-model="agreedToTerms"
                  @change="handleAgreementCheckboxChange"
                  class="custom-checkbox-input"
                />
                <span class="custom-checkbox-inner"></span>
                <span class="custom-checkbox-label">
                  已阅读并同意
                  <a href="javascript:void(0)" class="link-text" @click="handleAgreementClick">
                    《用户注册协议》
                  </a>
                  与
                  <a href="javascript:void(0)" class="link-text" @click="handlePrivacyClick">
                    《隐私政策》
                  </a>
                </span>
              </label>
            </div>
          </a-form>
        </div>
      </div>
    </div>

    <a-modal
      :visible="captchaModalVisible"
      title="请输入验证码"
      :footer="null"
      :maskClosable="false"
      :closable="true"
      width="420px"
      :centered="true"
      class="captcha-modal"
      :z-index="2000"
      @cancel="captchaModalVisible = false"
    >
      <div class="captcha-modal-content">
        <div class="captcha-image-section">
          <div class="captcha-image-wrapper" @click="getCode">
            <img v-if="codeUrl" class="captcha-image" :src="codeUrl" alt="验证码" />
            <div v-else class="captcha-loading">加载验证码中...</div>
            <div class="captcha-hint">点击刷新验证码</div>
          </div>
        </div>

        <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" class="captcha-input-item">
          <a-input
            v-model:value="form.validCode"
            size="large"
            placeholder="请输入验证码"
            @pressEnter="handleCaptchaSubmit"
            class="captcha-input"
          />
        </a-form-item>

        <div class="captcha-modal-footer">
          <a-button @click="captchaModalVisible = false" class="cancel-btn">取消</a-button>
          <a-button type="primary" @click="handleCaptchaSubmit" :loading="logining" class="save-btn">确认</a-button>
        </div>
      </div>
    </a-modal>

    <a-modal
      :visible="agreementModalVisible"
      title="用户注册协议"
      :footer="null"
      :maskClosable="false"
      :closable="agreementScrolledToBottom"
      width="800px"
      :centered="true"
      class="agreement-modal"
      @cancel="handleAgreementCancel"
      @update:visible="(val) => agreementModalVisible = val"
    >
      <div
        class="agreement-modal-content"
        v-loading="agreementLoading"
        ref="agreementContentRef"
        @scroll="handleAgreementScroll"
      >
        <div class="agreement-content-wrapper" v-html="agreementContent"></div>
        <div v-if="!agreementScrolledToBottom" class="scroll-hint">
          <ArrowDownOutlined /> 请滚动到底部阅读完整内容
        </div>
      </div>
      <div class="agreement-modal-footer">
        <a-button type="primary" :disabled="!agreementScrolledToBottom" @click="handleAgreementConfirm">
          我已阅读并同意
        </a-button>
      </div>
    </a-modal>

    <a-modal
      :visible="privacyModalVisible"
      title="隐私政策"
      :footer="null"
      :maskClosable="false"
      :closable="privacyScrolledToBottom"
      width="800px"
      :centered="true"
      class="privacy-modal"
      @cancel="handlePrivacyCancel"
      @update:visible="(val) => privacyModalVisible = val"
    >
      <div
        class="privacy-modal-content"
        v-loading="privacyLoading"
        ref="privacyContentRef"
        @scroll="handlePrivacyScroll"
      >
        <div class="privacy-content-wrapper" v-html="privacyContent"></div>
        <div v-if="!privacyScrolledToBottom" class="scroll-hint">
          <ArrowDownOutlined /> 请滚动到底部阅读完整内容
        </div>
      </div>
      <div class="privacy-modal-footer">
        <a-button type="primary" :disabled="!privacyScrolledToBottom" @click="handlePrivacyConfirm">
          我已阅读并同意
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { message, notification } from 'ant-design-vue'
import { ArrowDownOutlined } from '@ant-design/icons-vue'
import { timeFix } from '@/utils/util'
import { getCodeImg } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME, LOGIN_DEPTID } from '@/store/mutation-types'
import storage from 'store'
import { queryByGroupAndName } from '@/api/app/config'
import request from '@/utils/request'

const formRef = ref()
const agreementContentRef = ref(null)
const privacyContentRef = ref(null)

const form = reactive({
  accountNo: '',
  password: '',
  validCode: undefined,
  validCodeReqNo: '',
  rememberMe: false,
  deptId: undefined,
})

const rules = {
  accountNo: [{ required: true, message: '请输入账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
}

const codeUrl = ref('')
const isLoginError = ref(false)
const loginErrorInfo = ref('')
const logining = ref(false)
const captchaEnabled = ref(true)
const captchaModalVisible = ref(false)
const redirect = ref()

const agreedToTerms = ref(false)
const agreementModalVisible = ref(false)
const privacyModalVisible = ref(false)
const agreementContent = ref('')
const privacyContent = ref('')
const agreementLoading = ref(false)
const privacyLoading = ref(false)
const agreementScrolledToBottom = ref(false)
const privacyScrolledToBottom = ref(false)
const deptOptions = ref([])
const deptQueryTimer = ref(null)
const lastQueriedAccount = ref('')
const isInitializing = ref(true)

const store = useStore()
const router = useRouter()
const route = useRoute()

const primaryColor = computed(() => store.state.app?.color)
const themeColor = computed(() =>
  primaryColor.value && primaryColor.value !== '#101010' ? primaryColor.value : '#667eea'
)
const themeGradient = computed(() => generateGradientColors(themeColor.value))
const themeLightColor = computed(() => lightenColor(themeColor.value, 0.3))

watch(
  () => route.query,
  (q) => {
    redirect.value = q?.redirect
  },
  { immediate: true, deep: true }
)

// 监控验证码弹窗状态
watch(
  () => captchaModalVisible.value,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const modal = document.querySelector('.captcha-modal .ant-modal')
        if (modal) {
          console.log('验证码弹窗已显示')
        }
      })
    }
  }
)

onMounted(() => {
  getStorage()
  // 页面加载时初始化验证码状态
  initCaptcha()
})

// 初始化验证码
function initCaptcha() {
  getCodeImg()
    .then((res) => {
      captchaEnabled.value = res.data?.captchaEnabled === undefined ? true : res.data.captchaEnabled
      if (captchaEnabled.value && res.data) {
        codeUrl.value = 'data:image/gif;base64,' + res.data.img
        form.validCodeReqNo = res.data.uuid
      }
    })
    .catch((error) => {
      console.error('获取验证码配置失败:', error)
      // 如果获取失败，默认启用验证码
      captchaEnabled.value = true
    })
}

function getCode() {
  return getCodeImg()
    .then((res) => {
      captchaEnabled.value = res.data?.captchaEnabled === undefined ? true : res.data.captchaEnabled
      if (captchaEnabled.value && res.data) {
        codeUrl.value = 'data:image/gif;base64,' + res.data.img
        form.validCodeReqNo = res.data.uuid
      }
      return res
    })
    .catch((error) => {
      console.error('获取验证码失败:', error)
      message.error('获取验证码失败，请重试')
      throw error
    })
}

function getStorage() {
  const accountNo = storage.get(LOGIN_USERNAME)
  const password = storage.get(LOGIN_PASSWORD)
  const rememberMe = storage.get(LOGIN_REMEMBERME)
  const deptId = storage.get(LOGIN_DEPTID)
  if (accountNo) {
    form.accountNo = accountNo
    form.password = password
    form.rememberMe = rememberMe
    if (deptId) {
      form.deptId = deptId
    }
    fetchUserDepts(accountNo, deptId)
  }
  isInitializing.value = false
}

function rememberMe(e) {
  // v-model 已经自动更新，这里可以添加额外逻辑
}

// 处理协议复选框变化
function handleAgreementCheckboxChange(e) {
  // v-model 已经自动更新，这里可以添加额外逻辑
}

async function handleLoginClick() {
  console.log('登录按钮被点击')
  console.log('自动登录状态:', form.rememberMe)
  console.log('同意协议状态:', agreedToTerms.value)
  
  if (!formRef.value) {
    message.error('表单初始化失败，请刷新页面重试')
    return
  }
  
  if (logining.value) {
    return
  }
  
  try {
    await formRef.value.validate()
    
    if (!agreedToTerms.value) {
      message.warning('请先阅读并同意《用户注册协议》与《隐私政策》')
      return
    }
    
    // 如果存在多个部门且尚未选择，阻止登录
    if (deptOptions.value.length > 1 && !form.deptId) {
      message.warning('请选择所属部门')
      return
    }
    
    if (captchaEnabled.value) {
      try {
        await getCode()
        form.validCode = ''
        captchaModalVisible.value = true
      } catch (error) {
        console.error('获取验证码失败:', error)
        message.error('获取验证码失败，请重试')
      }
    } else {
      await doLogin()
    }
  } catch (e) {
    if (e && e.errorFields) {
      message.warning('请填写完整的登录信息')
    } else {
      console.error('未知错误:', e)
      message.error('登录过程中发生错误，请重试')
    }
  }
}

async function handleCaptchaSubmit() {
  if (!form.validCode) {
    message.warning('请输入验证码')
    return
  }
  await doLogin()
}

// 根据账号/手机号获取用户所属部门列表
async function fetchUserDepts(account, preferredDeptId) {
  const trimmed = (account || '').trim()
  if (!trimmed) {
    deptOptions.value = []
    form.deptId = undefined
    lastQueriedAccount.value = ''
    return
  }
  try {
    const res = await request({
      url: '/system/user/getUserDeptByPhoneOrAccount',
      method: 'get',
      params: { phoneOrAccount: trimmed },
    })
    const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : []
    deptOptions.value = list
    lastQueriedAccount.value = trimmed
    if (!list.length) {
      form.deptId = undefined
      return
    }
    const targetDeptId =
      (preferredDeptId && list.some((d) => d.deptId === preferredDeptId) && preferredDeptId) ||
      (form.deptId && list.some((d) => d.deptId === form.deptId) && form.deptId) ||
      list[0].deptId
    form.deptId = targetDeptId
  } catch (error) {
    console.error('获取用户部门失败:', error)
    deptOptions.value = []
    form.deptId = undefined
  }
}

// 实时监听账号输入，防抖后请求部门列表
watch(
  () => form.accountNo,
  (val) => {
    if (isInitializing.value) {
      return
    }
    const account = (val || '').trim()
    if (!account) {
      if (deptQueryTimer.value) {
        clearTimeout(deptQueryTimer.value)
        deptQueryTimer.value = null
      }
      deptOptions.value = []
      form.deptId = undefined
      lastQueriedAccount.value = ''
      return
    }
    if (deptQueryTimer.value) {
      clearTimeout(deptQueryTimer.value)
    }
    deptQueryTimer.value = setTimeout(() => {
      // 如果账号未变化，则不重复请求
      if (account === lastQueriedAccount.value) {
        return
      }
      fetchUserDepts(account)
    }, 600)
  }
)

async function doLogin() {
  logining.value = true
  if (form.rememberMe) {
    storage.set(LOGIN_USERNAME, form.accountNo)
    storage.set(LOGIN_PASSWORD, form.password)
    storage.set(LOGIN_REMEMBERME, form.rememberMe)
  } else {
    storage.remove(LOGIN_USERNAME)
    storage.remove(LOGIN_PASSWORD)
    storage.remove(LOGIN_REMEMBERME)
    storage.remove(LOGIN_DEPTID)
  }

  try {
    await store.dispatch('Login', { ...form })
    if (form.rememberMe) {
      storage.set(LOGIN_DEPTID, form.deptId)
    }
    captchaModalVisible.value = false
    logining.value = false
    
    const targetPath = redirect.value || '/index'
    // const targetPath = '/shujukanban/companyDashboard'

    console.log('登录成功，准备跳转到:', targetPath)
    
    try {
      await router.push({ path: targetPath })
      console.log('路由跳转成功')
    } catch (routerError) {
      console.error('路由跳转失败:', routerError)
      setTimeout(() => {
        router.push({ path: targetPath }).catch((err) => {
          console.error('重试路由跳转仍然失败:', err)
          message.error('页面跳转失败，请刷新页面')
        })
      }, 500)
    }
  } catch (err) {
    logining.value = false
    isLoginError.value = true
    loginErrorInfo.value = err?.message || '登录失败，请检查账号密码或验证码'
    console.error('登录失败:', err)
    // 接口报错时关闭验证码弹窗
    if (captchaModalVisible.value) {
      captchaModalVisible.value = false
    }
    if (captchaEnabled.value) {
      getCode()
      form.validCode = ''
    }
  }
}

function loginSuccess() {
  router.push({ path: '/' })
  setTimeout(() => {
    notification.success({
      message: '欢迎',
      description: `${timeFix()}，欢迎回来`,
    })
  }, 1000)
  handleCloseLoginError()
}

function requestFailed(err) {
  isLoginError.value = true
  loginErrorInfo.value = err
  form.code = undefined
  if (captchaEnabled.value) {
    getCode()
  }
}

function handleCloseLoginError() {
  isLoginError.value = false
  loginErrorInfo.value = ''
}

function handleAgreementClick(e) {
  if (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
  }
  console.log('handleAgreementClick 被调用', agreementModalVisible.value)
  agreementModalVisible.value = true
  console.log('设置后 agreementModalVisible:', agreementModalVisible.value)
  agreementScrolledToBottom.value = false
  if (!agreementContent.value) {
    loadAgreementContent()
  }
  nextTick(() => {
    checkAgreementScroll()
    console.log('nextTick 后 agreementModalVisible:', agreementModalVisible.value)
  })
}

function handlePrivacyClick(e) {
  if (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
  }
  console.log('handlePrivacyClick 被调用', privacyModalVisible.value)
  privacyModalVisible.value = true
  console.log('设置后 privacyModalVisible:', privacyModalVisible.value)
  privacyScrolledToBottom.value = false
  if (!privacyContent.value) {
    loadPrivacyContent()
  }
  nextTick(() => {
    checkPrivacyScroll()
    console.log('nextTick 后 privacyModalVisible:', privacyModalVisible.value)
  })
}

function handleAgreementScroll() {
  checkAgreementScroll()
}

function handlePrivacyScroll() {
  checkPrivacyScroll()
}

function checkAgreementScroll() {
  const el = agreementContentRef.value
  if (!el) return
  const { scrollTop, scrollHeight, clientHeight } = el
  if (scrollHeight <= clientHeight) {
    agreementScrolledToBottom.value = true
    return
  }
  agreementScrolledToBottom.value = scrollTop + clientHeight >= scrollHeight - 5
}

function checkPrivacyScroll() {
  const el = privacyContentRef.value
  if (!el) return
  const { scrollTop, scrollHeight, clientHeight } = el
  if (scrollHeight <= clientHeight) {
    privacyScrolledToBottom.value = true
    return
  }
  privacyScrolledToBottom.value = scrollTop + clientHeight >= scrollHeight - 5
}

function handleAgreementCancel() {
  if (!agreementScrolledToBottom.value) {
    message.warning('请先滚动到底部阅读完整内容后再关闭')
    nextTick(() => {
      agreementModalVisible.value = true
    })
    return
  }
  agreementModalVisible.value = false
  agreementScrolledToBottom.value = false
}

function handlePrivacyCancel() {
  if (!privacyScrolledToBottom.value) {
    message.warning('请先滚动到底部阅读完整内容后再关闭')
    nextTick(() => {
      privacyModalVisible.value = true
    })
    return
  }
  privacyModalVisible.value = false
  privacyScrolledToBottom.value = false
}

function handleAgreementConfirm() {
  if (!agreementScrolledToBottom.value) {
    message.warning('请先滚动到底部阅读完整内容')
    return
  }
  agreementModalVisible.value = false
  agreementScrolledToBottom.value = false
}

function handlePrivacyConfirm() {
  if (!privacyScrolledToBottom.value) {
    message.warning('请先滚动到底部阅读完整内容')
    return
  }
  privacyModalVisible.value = false
  privacyScrolledToBottom.value = false
}

async function loadAgreementContent() {
  agreementLoading.value = true
  try {
    const response = await queryByGroupAndName({
      configGroup: 'protocol',
      configName: 'userAgreement',
    })
    if (response && response.data && response.data.configValue) {
      agreementContent.value = response.data.configValue
    } else {
      agreementContent.value = getDefaultAgreementContent()
    }
  } catch (error) {
    agreementContent.value = getDefaultAgreementContent()
  } finally {
    agreementLoading.value = false
    nextTick(() => checkAgreementScroll())
  }
}

async function loadPrivacyContent() {
  privacyLoading.value = true
  try {
    const response = await queryByGroupAndName({
      configGroup: 'protocol',
      configName: 'privacyPolicy',
    })
    if (response && response.data && response.data.configValue) {
      privacyContent.value = response.data.configValue
    } else {
      privacyContent.value = getDefaultPrivacyContent()
    }
  } catch (error) {
    privacyContent.value = getDefaultPrivacyContent()
  } finally {
    privacyLoading.value = false
    nextTick(() => checkPrivacyScroll())
  }
}

function getDefaultAgreementContent() {
  return `
    <div class="default-content">
      <h2>用户注册协议</h2>
      <p>欢迎使用弘笃智慧云管理系统！</p>
      <p>在使用本系统之前，请您仔细阅读并同意本协议的全部内容。</p>
      <h3>一、服务条款的确认和接纳</h3>
      <p>本协议是您与弘笃智慧云管理系统之间关于使用本系统的法律协议。</p>
      <h3>二、用户账号</h3>
      <p>1. 用户在使用本系统前需要注册账号。</p>
      <p>2. 用户应当妥善保管账号和密码，不得将账号转让、出售或借给他人使用。</p>
      <h3>三、用户行为规范</h3>
      <p>用户在使用本系统时，应当遵守相关法律法规，不得从事违法违规行为。</p>
      <h3>四、隐私保护</h3>
      <p>我们将严格保护您的个人信息安全，具体内容请查看《隐私政策》。</p>
      <h3>五、免责声明</h3>
      <p>在法律允许的范围内，本系统不对因使用或无法使用本系统而产生的任何损失承担责任。</p>
      <h3>六、协议修改</h3>
      <p>我们有权随时修改本协议，修改后的协议将在系统中公布。</p>
      <p class="update-time">最后更新时间：${new Date().toLocaleDateString('zh-CN')}</p>
    </div>
  `
}

function getDefaultPrivacyContent() {
  return `
    <div class="default-content">
      <h2>隐私政策</h2>
      <p>弘笃智慧云管理系统（以下简称"我们"）非常重视用户的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。</p>
      <h3>一、信息收集</h3>
      <p>1. 我们可能收集以下信息：</p>
      <p>（1）账号信息：用户名、密码等注册信息；</p>
      <p>（2）使用信息：您在使用系统时的操作记录、登录日志等；</p>
      <p>（3）设备信息：设备型号、操作系统版本、IP地址等。</p>
      <h3>二、信息使用</h3>
      <p>我们使用收集的信息用于：</p>
      <p>1. 提供、维护和改进我们的服务；</p>
      <p>2. 处理您的请求和交易；</p>
      <p>3. 发送系统通知和重要信息；</p>
      <p>4. 进行数据分析，优化用户体验。</p>
      <h3>三、信息存储</h3>
      <p>我们采用行业标准的安全措施来保护您的个人信息，防止未经授权的访问、使用或泄露。</p>
      <h3>四、信息共享</h3>
      <p>我们不会向第三方出售、交易或转让您的个人信息，除非：</p>
      <p>1. 获得您的明确同意；</p>
      <p>2. 法律法规要求；</p>
      <p>3. 为提供服务所必需。</p>
      <h3>五、您的权利</h3>
      <p>您有权：</p>
      <p>1. 访问、更正或删除您的个人信息；</p>
      <p>2. 撤回您对信息处理的同意；</p>
      <p>3. 要求我们停止处理您的个人信息。</p>
      <h3>六、政策更新</h3>
      <p>我们可能会不定期更新本隐私政策，更新后的政策将在系统中公布。</p>
      <p class="update-time">最后更新时间：${new Date().toLocaleDateString('zh-CN')}</p>
    </div>
  `
}

function generateGradientColors(baseColor) {
  const rgb = hexToRgb(baseColor)
  if (!rgb) return [baseColor, baseColor, baseColor]
  const color1 = rgbToHex(Math.min(255, rgb.r + 20), Math.min(255, rgb.g + 20), Math.min(255, rgb.b + 20))
  const color2 = rgbToHex(Math.max(0, rgb.r - 30), Math.max(0, rgb.g - 30), Math.max(0, rgb.b - 30))
  return [baseColor, color1, color2]
}

function lightenColor(color, amount) {
  const rgb = hexToRgb(color)
  if (!rgb) return color
  const r = Math.min(255, Math.round(rgb.r + (255 - rgb.r) * amount))
  const g = Math.min(255, Math.round(rgb.g + (255 - rgb.g) * amount))
  const b = Math.min(255, Math.round(rgb.b + (255 - rgb.b) * amount))
  return rgbToHex(r, g, b)
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
    : null
}

function rgbToHex(r, g, b) {
  return (
    '#' +
    [r, g, b]
      .map((x) => {
        const hex = Math.round(x).toString(16)
        return hex.length === 1 ? '0' + hex : hex
      })
      .join('')
  )
}
</script>

<style lang="less" scoped>
.login-page-wrapper {
  width: 100%;
  min-height: 100vh;
  background-image: url('@/assets/bg1.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  display: flex;
  width: 1350px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 700px;
}

.login-left-panel {
  width: 600px;
  height: 700px;
  background-image: url('@/assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 30px 30px;
  
  .logo-section {
    z-index: 2;
    position: relative;

    .logo-image {
      width: 65px;
      height: auto;
      margin-bottom: 12px;
      display: block;
    }
  }
}

.login-right-panel {
  width: 750px;
  height: 700px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 50px;
  
  .login-form-wrapper {
    width: 100%;
    max-width: 500px;
    margin-left: 0;
  }
}

.login-header {
  margin-bottom: 30px;
  text-align: left;
  
  .login-title {
    width: auto;
    min-height: 42px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 28px;
    color: #165DFF;
    letter-spacing: 6px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 0 0 10px 0;
    line-height: 1.4;
    white-space: nowrap;
    overflow: visible;
  }

  .login-subtitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #101010;
    letter-spacing: 4px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 0;
  }
}

.user-layout-login {
  position: relative;
  z-index: 2;
  
  label {
    font-size: 14px;
  }

  :deep(.ant-form-item) {
    margin-bottom: 24px;

    .ant-form-item-explain {
      margin-top: 4px;
      margin-left: 0 !important;
      padding-left: 0 !important;
      text-align: left;
      line-height: 1.5;
      position: relative;
      left: 0;
    }

    .ant-form-item-control {
      width: 100%;
      padding-left: 0;
      margin-left: 0;

      .ant-form-item-control-input {
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        .ant-form-item-control-input-content {
          margin-left: 0;
          padding-left: 0;
          width: 100%;
        }
      }
    }

    &.ant-form-item-with-help {
      margin-bottom: 24px;
    }
  }

  :deep(.ant-form-item-label) {
    width: 100%;
    padding: 0;
    margin-bottom: 8px;

    label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #101010;
      letter-spacing: 2px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      width: 100%;
      display: block;
    }
  }

  :deep(.ant-form-item:last-child) {
    margin-bottom: 0;
  }

  .password-form-item {
    margin-left: 0 !important;
    
    :deep(.ant-form-item-control) {
      margin-left: 0 !important;
    }
    
    :deep(.ant-form-item-control-input) {
      margin-left: 0 !important;
    }
    
    :deep(.ant-form-item-control-input-content) {
      margin-left: 0 !important;
    }
    
    .login-input {
      :deep(.ant-input-affix-wrapper) {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        
        .ant-input {
          padding-left: 0 !important;
        }
      }
    }
  }

  :deep(.ant-input-affix-wrapper) {
    border-radius: 8px;
    border: 1px solid #CCCCCC;
    transition: all 0.3s ease;
    font-size: 14px;
    background: #FFFFFF;
    outline: none !important;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    height: 48px;

    &:hover {
      border-color: #40a9ff;
    }

    &:focus,
    &:focus-within,
    &.ant-input-affix-wrapper-focused {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    .ant-input {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent;
      border-radius: 0;
      padding: 0 16px;
      box-sizing: border-box;
      height: 100%;
      line-height: 48px;
      display: block;
      vertical-align: middle;

      &:focus {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;
        background: transparent;
      }

      &::placeholder {
        color: #bfbfbf;
        line-height: 48px;
        vertical-align: middle;
        opacity: 1;
      }
    }
  }

  :deep(.ant-input-affix-wrapper-lg) {
    padding-left: 0 !important;
  }

  :deep(.ant-input) {
    border-radius: 8px;
    border: 1px solid #CCCCCC;
    transition: all 0.3s ease;
    font-size: 14px;
    background: #FFFFFF;
    outline: none !important;
    box-sizing: border-box;
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    display: block;
    vertical-align: middle;

    &:hover {
      border-color: #40a9ff;
    }

    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &::placeholder {
      color: #bfbfbf;
      line-height: 48px;
      vertical-align: middle;
      opacity: 1;
    }
  }

  .login-input {
    width: 100%;
    
    :deep(.ant-input-affix-wrapper) {
      width: 100%;
      height: 48px !important;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #CCCCCC;
      display: flex;
      align-items: center;
      padding-left: 0 !important;

      .ant-input {
        height: 100% !important;
        line-height: 48px !important;
        display: block;
        vertical-align: middle;
        padding: 0 16px !important;

        &::placeholder {
          line-height: 48px !important;
          vertical-align: middle;
        }
      }
    }

    :deep(.ant-input) {
      width: 100%;
      height: 48px !important;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #CCCCCC;
      padding: 0 16px !important;
      line-height: 48px !important;
      display: block;
      vertical-align: middle;

      &::placeholder {
        line-height: 48px !important;
        vertical-align: middle;
      }
    }
  }

  // 自定义checkbox样式
  .custom-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    position: relative;
    
    .custom-checkbox-input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
      margin: 0;
      padding: 0;
    }
    
    .custom-checkbox-inner {
      position: relative;
      width: 18px;
      height: 18px;
      background: #FFFFFF;
      border: 1px solid #CCCCCC;
      border-radius: 3px;
      transition: all 0.3s ease;
      flex-shrink: 0;
      display: block;
      
      &::after {
        position: absolute;
        top: 2px;
        left: 6px;
        width: 5.71428571px;
        height: 9.14285714px;
        border: 2px solid #ffffff;
        border-top: 0;
        border-left: 0;
        transform: rotate(45deg) scale(0);
        opacity: 0;
        transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
        content: ' ';
        display: block;
      }
    }
    
    .custom-checkbox-input:checked + .custom-checkbox-inner {
      background: #1890ff;
      border-color: #1890ff;
      
      &::after {
        opacity: 1;
        transform: rotate(45deg) scale(1);
      }
    }
    
    .custom-checkbox-input:hover + .custom-checkbox-inner {
      border-color: #1890ff;
    }
    
    .custom-checkbox-label {
      margin-left: 8px;
      font-size: 14px;
      color: #101010;
      line-height: 1.5;
    }
    
    &:hover .custom-checkbox-inner {
      border-color: #1890ff;
    }
  }

  .remember-me-item {
    margin-top: 16px;
    
    .custom-checkbox-wrapper {
      .custom-checkbox-label {
        font-size: 14px;
        color: #101010;
      }
    }
  }

  .login-button {
    height: 48px;
    width: 100%;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    background: #165DFF;
    border: none;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      background: #165DFF;
    }

    &:active:not(:disabled) {
      background: #165DFF;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .agreement-section {
    width: 100%;
    margin-top: 20px;
    text-align: center;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .custom-checkbox-wrapper {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      
      .custom-checkbox-label {
        font-size: 12px;
        color: #666;
        line-height: 1.4;
        
        .link-text {
          color: #1890ff;
          text-decoration: none;
          margin: 0 2px;
          cursor: pointer;
          position: relative;
          z-index: 10;
          pointer-events: auto;

          &:hover {
            text-decoration: underline;
            color: #40a9ff;
          }
          
          &:active {
            color: #096dd9;
          }
        }
      }
    }
  }
}

.captcha-modal-content {
  padding: 0;
  
  .captcha-image-section {
    margin-bottom: 24px;
    width: 100%;
  }

  .captcha-input-item {
    margin-bottom: 0;
    width: 100%;
  }

  :deep(.captcha-input) {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    padding: 0 16px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #ffffff;

    &:hover {
      border-color: #40a9ff;
    }

    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      outline: none;
    }

    &::placeholder {
      color: #bfbfbf;
    }
  }

  .captcha-image-wrapper {
    position: relative;
    width: 100%;
    min-height: 80px;
    height: auto;
    cursor: pointer;
    border: 2px solid #d9d9d9;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 8px;

    &:hover {
      border-color: #1890ff;
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
      transform: translateY(-2px);
    }

    .captcha-image {
      width: 100%;
      height: auto;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }

    .captcha-hint {
      position: absolute;
      bottom: -24px;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 12px;
      color: #1890ff;
      opacity: 0;
      transition: opacity 0.3s ease;
      font-weight: 500;
      white-space: nowrap;
    }

    &:hover .captcha-hint {
      opacity: 1;
    }
  }

  .captcha-modal-footer {
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  /* 验证码弹窗保存按钮样式 - 参照CreateForm.vue */
  .captcha-modal .save-btn,
  .save-btn {
    background-color: #165DFF !important;
    border-color: #165DFF !important;
    color: #FFFFFF !important;
    border-radius: 4px 4px 4px 4px !important;
  }

  .captcha-modal .save-btn:hover,
  .save-btn:hover {
    background-color: #165DFF !important;
    border-color: #165DFF !important;
    color: #FFFFFF !important;
    opacity: 0.9;
    border-radius: 4px 4px 4px 4px !important;
  }

  .captcha-modal .save-btn:focus,
  .save-btn:focus {
    border-radius: 4px 4px 4px 4px !important;
  }

  /* 验证码弹窗取消按钮样式 - 参照CreateForm.vue */
  .captcha-modal .cancel-btn,
  .cancel-btn {
    background-color: #F3F3F3 !important;
    border-color: #F3F3F3 !important;
    color: #101010 !important;
    border-radius: 4px 4px 4px 4px !important;
  }

  .captcha-modal .cancel-btn:hover,
  .cancel-btn:hover {
    background-color: #F3F3F3 !important;
    border-color: #F3F3F3 !important;
    color: #101010 !important;
    border-radius: 4px 4px 4px 4px !important;
  }

  .captcha-modal .cancel-btn:focus,
  .cancel-btn:focus {
    border-radius: 4px 4px 4px 4px !important;
  }
}

.agreement-modal-content,
.privacy-modal-content {
  min-height: 400px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;
  
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;

    &:hover {
      background: #a8a8a8;
    }
  }

  .scroll-hint {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.8) 70%,
      transparent 100%
    );
    padding: 16px 0 8px 0;
    text-align: center;
    color: #1890ff;
    font-size: 14px;
    margin-top: 16px;
    pointer-events: none;
    z-index: 10;

    .anticon {
      margin-right: 4px;
      animation: bounce 1.5s infinite;
    }
  }

  .agreement-content-wrapper,
  .privacy-content-wrapper {
    line-height: 1.8;
    color: #333;
    font-size: 14px;

    :deep(h2) {
      font-size: 22px;
      font-weight: 600;
      color: #1890ff;
      margin: 0 0 16px 0;
      text-align: center;
    }

    :deep(h3) {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 20px 0 12px 0;
    }

    :deep(p) {
      margin: 12px 0;
      color: #666;
      text-align: justify;
    }

    :deep(.update-time) {
      margin-top: 32px;
      color: #999;
      font-size: 12px;
      text-align: right;
    }
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

.agreement-modal-footer,
.privacy-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  text-align: center;
  background: #fafafa;
  
  .ant-btn {
    min-width: 160px;
    height: 40px;
    font-size: 14px;
  }
}

/* 大屏适配（≥1920px） */
@media (min-width: 1920px) {
  .login-page-wrapper {
    padding: ~"min(48px, 2.5vw)";
    box-sizing: border-box;
  }

  .login-container {
    width: ~"min(70vw, 1760px)";
    height: ~"min(860px, 54vh)";
    min-height: 760px;
    max-height: 90vh;
    border-radius: 24px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.18);
    box-sizing: border-box;
  }

  .login-left-panel {
    width: 52%;
    height: 100%;
    min-height: 0;
    padding: 40px 48px;

    .logo-section {
      .logo-image {
        width: 80px;
        margin-bottom: 20px;
      }
    }
  }

  .login-right-panel {
    width: 48%;
    height: 100%;
    min-height: 0;
    padding: 64px 80px;

    .login-form-wrapper {
      max-width: 560px;
    }
  }

  .login-header {
    margin-bottom: 40px;

    .login-title {
      font-size: 32px;
      letter-spacing: 8px;
      min-height: 48px;
    }

    .login-subtitle {
      font-size: 18px;
      letter-spacing: 5px;
    }
  }

  .user-layout-login {
    label {
      font-size: 15px;
    }

    :deep(.ant-form-item) {
      margin-bottom: 28px;
    }

    :deep(.ant-input),
    :deep(.ant-input-affix-wrapper) {
      height: 52px;
      font-size: 15px;
    }

    .login-input {
      :deep(.ant-input),
      :deep(.ant-input-affix-wrapper) {
        height: 52px !important;
        line-height: 52px !important;
      }
    }

    .remember-me-item {
      margin-top: 20px;

      .custom-checkbox-label {
        font-size: 15px;
      }
    }

    .agreement-section {
      margin-top: 28px;

      .custom-checkbox-label {
        font-size: 13px;
      }
    }

    .login-button {
      height: 52px;
      font-size: 18px;
      border-radius: 10px;
    }
  }
}

/* 超宽屏专属：2560×1600 等分辨率，容器宽高按视口比例适配 */
@media (min-width: 2560px) {
  .login-page-wrapper {
    padding: ~"min(64px, 2.5vw)";
  }

  .login-container {
    width: ~"min(72vw, 1920px)";
    min-width: 1680px;
    height: ~"min(920px, 58vh)";
    min-height: 840px;
    max-height: 92vh;
    border-radius: 28px;
    box-shadow: 0 32px 96px rgba(0, 0, 0, 0.2);
  }

  .login-left-panel {
    padding: 48px 56px;

    .logo-section .logo-image {
      width: 88px;
      margin-bottom: 24px;
    }
  }

  .login-right-panel {
    padding: 72px 88px;

    .login-form-wrapper {
      max-width: 580px;
    }
  }

  .login-header {
    margin-bottom: 44px;

    .login-title {
      font-size: 34px;
      letter-spacing: 10px;
      min-height: 52px;
    }

    .login-subtitle {
      font-size: 19px;
      letter-spacing: 6px;
    }
  }

  .user-layout-login {
    :deep(.ant-form-item) {
      margin-bottom: 30px;
    }

    :deep(.ant-input),
    :deep(.ant-input-affix-wrapper) {
      height: 54px;
      font-size: 16px;
    }

    .login-input :deep(.ant-input),
    .login-input :deep(.ant-input-affix-wrapper) {
      height: 54px !important;
      line-height: 54px !important;
    }

    .login-button {
      height: 54px;
      font-size: 18px;
      border-radius: 12px;
    }
  }
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }
  
  .login-left-panel {
    display: none;
  }
  
  .login-right-panel {
    width: 100%;
    padding: 20px;
  }
  
  .login-input {
    width: 100% !important;
    
    :deep(.ant-input-affix-wrapper),
    :deep(.ant-input) {
      width: 100% !important;
    }
  }
}
</style>